import React from 'react'

const Title = ({ title }) => {
  return (
    <span className="d-flex">
      <h5 className="font-weight-bold mb-0">{title}</h5>
    </span>
  )
}

export default Title
